import { withVersions } from "v2/hocs/withVersions";
import { HeaderToast as ToastV1UI } from "./Toast/v1";
import { HeaderToast as ToastV2UI } from "./Toast/v2";

const Toast = withVersions({
  v1: ToastV1UI,
  v2: ToastV2UI,
});

export { Toast };
